export const formatPrice = (
  price: number,
  currency = "£",
  fractionLen = 2
): string => {
  if (price % 1 === 0) return `${currency}${price}`;
  return `${currency}${Number(price).toFixed(fractionLen)}`;
};
